import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { cn } from "@repo/ui/lib/utils";
import { ComponentPropsWithoutRef, ElementRef, forwardRef } from "react";
import { useFormField } from "@repo/ui/components/ui/form";

const Checkbox = forwardRef<
  ElementRef<typeof CheckboxPrimitive.Root>,
  ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, children, ...props }, ref) => {
  let formField;

  try {
    formField = useFormField();
  } catch (e) {
    formField = null;
  }

  return (
    <label
      className={cn(
        "flex items-center text-[12px] text-secondary-black dark:text-primary-white",
        { "text-secondary-red dark:text-secondary-red": formField?.error },
      )}
    >
      <CheckboxPrimitive.Root
        ref={ref}
        className={cn(
          "group mr-[16px] h-[24px] max-w-[24px] min-w-[24px] rounded-[5px] border-[2px] border-secondary-black dark:border-primary-white border-opacity-50 dark:border-opacity-1 bg-[#F8F6F7] dark:bg-secondary-gray1",
          {
            "ring-[2px] ring-secondary-red [&_*]:text-secondary-red":
              formField?.error,
          },
          className,
        )}
        {...props}
      >
        <CheckboxPrimitive.Indicator
          className={cn("flex items-center justify-center text-current")}
        >
          <svg
            className="fill-primary-magenta group-disabled:fill-secondary-black/70"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <circle cx="12" cy="10" r="5" />
          </svg>
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      {children}
    </label>
  );
});
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
